export default {"src":"/_next/static/media/Hydrocephalus.3fa58f12.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};